import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { AuthProvider } from './utils/AuthContext';

import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import UpcomingReleases from "./components/UpcomingReleases";
import NewReleases from "./components/NewReleases";
import CalendarPage from "./pages/calendarpage";
import Footer from "./components/Footer";

import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsofUse from "./pages/TermsofUse";
import SignupModal from './components/SignupModal';
import ProfileDashboard from "./pages/ProfileDashboard";
import MyGames from './pages/MyGames';
import Game from './pages/Game';
import GameDetails from './pages/GameDetails';
import TrackerGame from './pages/TrackerGame';
import ResetPassword from './pages/ResetPassword';
import Contact from './pages/Contact';

import ReactGA from "react-ga4";

// Initialize GA4 with proper configuration
ReactGA.initialize(process.env.REACT_APP_GA_ID, {
  gaOptions: {
    cookieFlags: 'SameSite=None;Secure',
    allowAdFeatures: false,
    allowAdPersonalizationSignals: false
  }
});

function App() {
  const location = useLocation();
  const [showSignupModal, setShowSignupModal] = useState(false);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  useEffect(() => {
    const handleShowSignupModal = () => {
      setShowSignupModal(true);
    };

    window.addEventListener('showSignupModal', handleShowSignupModal);

    return () => {
      window.removeEventListener('showSignupModal', handleShowSignupModal);
    };
  }, []);

  return (
    <AuthProvider>
      <div className="flex flex-col min-h-screen bg-gray-900 text-white">
        <Helmet>
          <meta httpEquiv="X-Content-Type-Options" content="nosniff" />
          <meta httpEquiv="X-XSS-Protection" content="1; mode=block" />
          <meta httpEquiv="Referrer-Policy" content="strict-origin-when-cross-origin" />
        </Helmet>
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={
              <>
                <HeroSection />
                <UpcomingReleases />
                <NewReleases />
              </>
            } />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/tracker-game" element={<TrackerGame />} />
            <Route path="/game/:id" element={<Game />} />
            <Route path="/game-details/:id" element={<GameDetails />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsofUse />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/profile" element={<ProfileDashboard />} />
            <Route path="/my-games" element={<MyGames />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        </main>
        <Footer />

        {/* Signup Modal */}
        <SignupModal 
          isOpen={showSignupModal} 
          onClose={() => setShowSignupModal(false)} 
        />
      </div>
    </AuthProvider>
  );
}

export default App;
